import { chartModules } from '../domain/catalog';
import type { ChartModuleId, ModuleCategory } from '../domain/types';

const categories: ModuleCategory[] = ['易学占筮', '三式', '命理', '择日与时空'];

export function ModulePicker({ selectedId, onSelect }: { selectedId: ChartModuleId; onSelect: (id: ChartModuleId) => void }) {
  return (
    <section className="module-picker" aria-labelledby="module-picker-title">
      <div className="section-heading compact-heading">
        <span className="eyebrow">选择方法</span>
        <h2 id="module-picker-title">十二门术数</h2>
      </div>
      {categories.map((category) => (
        <div className="module-group" key={category}>
          <h3>{category}</h3>
          <div className="module-list">
            {chartModules.filter((item) => item.category === category).map((module) => (
              <button
                key={module.id}
                type="button"
                className={module.id === selectedId ? 'module-button is-selected' : 'module-button'}
                aria-pressed={module.id === selectedId}
                aria-label={`${module.shortName}：${module.name}`}
                onClick={() => onSelect(module.id)}
              >
                <span className={`module-glyph accent-${module.accent}`}>{module.shortName.slice(0, 1)}</span>
                <span className="module-copy">
                  <strong>{module.shortName}</strong>
                  <small>{module.tradition.split('、')[0]}</small>
                </span>
                <span aria-hidden="true" className="module-chevron">›</span>
              </button>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}

